var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3786 5.895L15.45 0.0894785C15.309 0.0305321 15.1554 0 15 0C14.8446 0 14.691 0.0305321 14.55 0.0894785L0.621432 5.895C0.435453 5.97273 0.278059 6.09699 0.167915 6.25306C0.0577702 6.40912 -0.000503812 6.59044 3.2815e-06 6.77551V23.2245C-0.000503812 23.4096 0.0577702 23.5909 0.167915 23.7469C0.278059 23.903 0.435453 24.0273 0.621432 24.105L14.55 29.9105C14.691 29.9695 14.8446 30 15 30C15.1554 30 15.309 29.9695 15.45 29.9105L29.3786 24.105C29.5645 24.0273 29.7219 23.903 29.8321 23.7469C29.9422 23.5909 30.0005 23.4096 30 23.2245V6.77551C30.0005 6.59044 29.9422 6.40912 29.8321 6.25306C29.7219 6.09699 29.5645 5.97273 29.3786 5.895ZM15 11.5167L3.63215 6.77551L15 2.03433L26.3679 6.77551L15 11.5167ZM27.8571 22.6052L16.0714 27.5206V13.2003L27.8571 8.28494V22.6052Z",
    fill: "#BD6600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.7e0c3739d5cf77d699532aa01221b954.svg";
export { ForwardRef as ReactComponent };